import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PRODUCT_ID } from "../constants/constants";
import { updatePermissionState } from "../redux/permissionSlice";
import { setSnackbar } from "../redux/messageSlice";
import { findKeyAnywhereInJson, showSnackBar } from "../utils/commonServices";
import { getListOfAllRolesApi, getPermissionsListApi, getUserPermissionsApi } from "../services/api";
import { updateState } from "../redux/commonSlice";
import { setDropDownArray } from "../redux/dropdownSlice";




export default ()=> {
 
  const dispatch = useDispatch();
  const commonReducer = useSelector(state=> state.root.commonReducer)
  const location = useLocation();
  const permissionsReducer = useSelector((state) => state.permissionsReducer)
  const query = new URLSearchParams(location.search);
  const code = query.get('c')
  const navigate = useNavigate()
 

 ////////////////////GET get permissions list api   api/v1/permissions?product_id=4//////////////////////////

  const getPermissions = () => {
     const payload = {
         id: PRODUCT_ID?.pharaoh
     } 
   getPermissionsListApi(payload) 
   .then((response) => {
    //  console.log( response?.data?.data)
     if(response?.data?.http_code === 200){
         dispatch(updatePermissionState({permissions_list: response?.data?.data}))
     }else {
         dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
     }
   })
   .catch((error) => {
     if(error) {
     const errorObject = error?.response?.data;
     showSnackBar(dispatch, errorObject);
    // dispatch(setSnackbar({type:'error', flag:true, message: error.message}))
     }
   });
 }


  const getUserRoles = (  payload , callback) => {
 getUserPermissionsApi(payload) 
 .then((response) => {
   if(response?.data?.http_code === 200){
       const userPermissionArray = findKeyAnywhereInJson(response?.data?.data?.permissions, "key")
       const mappedObject = Object.keys(permissionsReducer.permissions_master).reduce((result, key) => {
         // Perform some operation on the value and store it in the result object
          if(userPermissionArray?.includes(key)) {
           result[key] = true //{...state.permissions_master[key], hasPermission: true}
          } else {
           // result[key] = state.permissions_master[key]
           result[key] = false // {...state.permissions_master[key], hasPermission: false}
          }
        // result[key] = myObject[key].toUpperCase();
         return result;
       }, {});
       // console.log({mappedObject})
       dispatch(updateState({role_id: response?.data?.data?.id, role_name: response?.data?.data?.name}))
       if(response?.data?.data?.id === 12 || response?.data?.data?.name === "Admin" ){
         dispatch(updateState({is_admin: true}))
       }
       dispatch(updatePermissionState({user_permissions: response?.data?.data, permissions_master: mappedObject}))
       callback && callback(mappedObject)
   }else {
       dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
   }
 })
 .catch((error) => {
   if(error) {
   const errorObject = error?.response?.data;
   showSnackBar(dispatch, errorObject);
   if(errorObject?.http_code == 403){
    navigate('/dashboard', {replace:true})
   }
  // dispatch(setSnackbar({type:'error', flag:true, message: error.message}))
   }
 });
 }


  const getRoles = () => {
   const payload = {
     product_id: 4
   }
   getListOfAllRolesApi(payload) 
 .then((response) => {
 
   if(response?.status === 200){
    // console.log('response roles list ---', response.data.data)
      dispatch(setDropDownArray({organisation_roles: response?.data?.data, team_roles: response?.data?.data, project_roles: response?.data?.data}))
   }else {
       dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
   }
 })
 .catch((error) => {
   if(error) {
   // console.error('error:', error);
   const errorObject = error?.response?.data;
   showSnackBar(dispatch, errorObject);
  // dispatch(setSnackbar({type:'error', flag:true, message: 'error'}))
   }
 });
 }
     


    

  return {getPermissions, getUserRoles , getRoles};
}